import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faGlobe } from '@fortawesome/pro-regular-svg-icons/faGlobe';
import { faCircle as faCircleSolid } from '@fortawesome/pro-solid-svg-icons/faCircle';
import clsx from 'clsx';
import type { FC } from 'react';

import { Menu } from '@furality/furality-purpose';
import FontAwesomeIcon from '#/components/FontAwesomeIcon.tsx';
import Placeholder from '@/components/Placeholder.tsx';
import useLanguage from '@/lib/hooks/useLanguage.ts';
import useLoading from '@/lib/hooks/useLoading.ts';
import { ENABLED_LANGUAGES } from '@/lib/i18n/i18n.ts';

const LanguageChangerDropdown: FC = () => {
  const { language, i18n } = useLanguage();

  const selectLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const loading = useLoading();

  return (
    <Menu
      align="start"
      title={
        <>
          <FontAwesomeIcon icon={faGlobe} className="mx-0" />
          <span className="visually-hidden">
            {loading ? <Placeholder width="5em" /> : language.name}
          </span>
        </>
      }
    >
      <ul
        // TODO: less magic
        className="ps-0 mb-0"
        style={{
          listStyle: 'none',
        }}
      >
        {ENABLED_LANGUAGES.map(([code, lang]) => {
          const active = i18n.resolvedLanguage === code;
          return (
            // TODO: button?
            <li key={code} className={clsx(active && 'active')}>
              <button
                type="button"
                lang={code}
                className="subtle-button"
                onClick={() => selectLanguage(code)}
              >
                <FontAwesomeIcon
                  icon={active ? faCircleSolid : faCircle}
                  className="ml-0 mr-2"
                  fontSize={10}
                />
                {lang.name}
              </button>
            </li>
          );
        })}
      </ul>
    </Menu>
  );
};

export default LanguageChangerDropdown;
